module.exports = __webpack_public_path__ + "media/images/meeting/ic_calendar-bf481217b7abfd6259f05e8c264f3614.svg";